import { ChangeDetectorRef, Directive, ElementRef, Renderer2, SkipSelf } from '@angular/core';
import { AbstractControl, FormControl, NgControl } from '@angular/forms';

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: '[formControlName], [formControl]',
})
// eslint-disable-next-line @angular-eslint/directive-class-suffix
export class FormControlTouchStatusPatchDirective {
  private control: AbstractControl = new FormControl();
  private touched: boolean;

  constructor(
    @SkipSelf() private cdRef: ChangeDetectorRef,
    private ngControl: NgControl,
    private renderer: Renderer2,
    private elRef: ElementRef,
  ) {
    this.patchNgControl(ngControl);
  }

  private patchNgControl(ngControl: NgControl): void {
    Object.defineProperty(ngControl, 'control', {
      get: () => this.control,
      set: (control: FormControl) => {
        this.control = this.patchAbstractControl(control);
      },
    });
  }

  private patchAbstractControl(control: AbstractControl): AbstractControl {
    this.touched = control.touched;
    Object.defineProperty(control, 'touched', {
      get: () => this.touched,
      set: (touched: boolean) => {
        if (touched === this.touched) return;
        this.touched = touched;
        if (touched) {
          this.renderer.removeClass(this.elRef.nativeElement, 'ng-untouched');
          this.renderer.addClass(this.elRef.nativeElement, 'ng-touched');
        } else {
          this.renderer.removeClass(this.elRef.nativeElement, 'ng-touched');
          this.renderer.addClass(this.elRef.nativeElement, 'ng-untouched');
        }
      },
    });

    return control;
  }
}
